
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Information/Information.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Information.html');
        
        var script = require('./Information.ts').default;
        module.exports = require('./Information.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    